<template>
    <!-- Основной layout страницы -->
    <MainLayout>
        <!-- Блок с данными пользователя -->
        <DropUserComponent />

        <!-- Контейнер для кошелька и данных о заказах -->
        <div class="wallet-data-container">
            <!-- Кошелек -->
            <DropWalletComponent />

            <!-- Блок данных о продажах -->
            <DropOrdersComponent />
        </div>

        <!-- Блок сортировки заказов -->
        <SortComponent @filters-change="handleFiltersChange" />

        <!-- Блок отображения заказов -->
        <TestDropOrdersComponent :filters="activeFilters" />

        <!-- Меню с личным кабинетом для дропов -->
        <DropMenu style="position: fixed; bottom: 20px; right: 0px;"/>
    </MainLayout>
</template>

<script>
// import api from '@/api/api';
import DropMenu from '@/components/DropMenu.vue';
import MainLayout from '@/components/MainLayout.vue';
import DropUserComponent from '@/components/DropUserComponent.vue';
import DropWalletComponent from '@/components/DropWalletComponent.vue';
import DropOrdersComponent from '@/components/DropOrdersComponent.vue';
import SortComponent from '@/components/SortComponent.vue';
import TestDropOrdersComponent from '@/components/DropOrdersCardComponent.vue';

export default {
  components: {
    MainLayout,
    DropMenu,
    DropUserComponent,
    DropWalletComponent,
    DropOrdersComponent,
    SortComponent,
    TestDropOrdersComponent,
  },
  data() {
    return {
      activeFilters: {}
    };
  },
  methods: {
    handleFiltersChange(filters) {
      this.activeFilters = { ...filters };
    }
  }
};
</script>

<style scoped>
.wallet-data-container {
    margin-top: 1.5vw;
    display: grid;
    grid-template-columns: 7fr 9fr;
    height: 40vw;
    width: 100%;
    position: relative;
    gap: 1.5vw;
    margin-bottom: 2vw;
}
</style>